export const convertValueToString = (
  value: string | number | boolean | undefined,
) => {
  if (typeof value === 'undefined') return '';
  if (typeof value === 'boolean') return value.toString();
  if (typeof value === 'number') return value.toString();
  return value;
};

export const objectHasDefinedValue = (obj?: Record<string, any>) => {
  if (!obj) return false;

  return Object.values(obj).some(Boolean);
};
